export default `#version 300 es

// an attribute is an input (in) to a vertex shader.
// It will receive data from a buffer
in vec2 position;
in vec2 textureCoord;

uniform vec2 resolution;
uniform float isFlipped;
uniform mat3 u_textureMatrix;

out vec2 vertexCoord;

// all shaders have a main function
void main() {
    vec2 zeroToOne = position / resolution;
    vec2 zeroToTwo = zeroToOne * 2.0;
    vec2 clipSpace = zeroToTwo - 1.0;

    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);

    if(isFlipped == 1.0) {
        vertexCoord = (u_textureMatrix * vec3(1.0 - textureCoord.x, textureCoord.y, 1)).xy;
    } else {
        vertexCoord = (u_textureMatrix * vec3(textureCoord, 1)).xy;
    }
}
`